/**
 * MS Amlin horsebox-api application JSON keys for overnight locations and correspondence.
 * Update to match the official API guide if names differ.
 */
export const AMLIN_VEHICLE_OVERNIGHT_ADDRESSES = 'overnight_addresses';
export const AMLIN_APPLICATION_CORRESPONDENCE_ADDRESS = 'correspondence_address';
